// extracted by mini-css-extract-plugin
module.exports = {"terms_box":"terms_box___1CRdA","cycle_item":"cycle_item___3R3Q-","body_text":"body_text___19osv","body_text_pre":"body_text_pre___1tSSI"};